import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavigationContextType {
  isNavigationVisible: boolean;
  showNavigation: () => void;
  hideNavigation: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isNavigationVisible, setIsNavigationVisible] = useState(false);

  const showNavigation = () => setIsNavigationVisible(true);
  const hideNavigation = () => setIsNavigationVisible(false);

  return (
    <NavigationContext.Provider value={{ isNavigationVisible, showNavigation, hideNavigation }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}; 